module.exports = __webpack_public_path__ + "static/img/language.ef8b9eb0.png";